export enum UserType {
  None = 'None',
  User = 'User',
  PlatformAdmin = 'PlatformAdmin'
}

export enum UserRole {
  Create = 'Create',
  Approve = 'Approve'
}

export interface User {
  email: string
  name: string
  picture: string
  roles: string[]
  canAccessAllAccounts: boolean
  userType?: UserType
  userRoles?: UserRole[]
}

export interface OrganizationUser {
  id: string
  name: string
  email: string
  canAccessAllAccounts: boolean
  userType: UserType
  userRoles: UserRole[]
}

export interface UserAccess {
  userType: UserType
  userRoles: UserRole[]
}
